import React, { useContext } from 'react';
import { UserContext } from '../functions/Auth';

// component
import NotificationPane from '../components/Notification/NotificationPane';

// mui
import Box from '@mui/material/Box';

export default function Notifications() {
    const userInfo = useContext(UserContext);
    const userId = userInfo?.userId;
    const rooms = userInfo?.rooms;

    return (
        <Box
            sx={{
                maxWidth: 980,
                mx: "auto",
                px: 0,
                pt: 3,
                pb: 6,
            }}
        >
        {rooms && userId &&
            rooms.map((room) => {
                return <NotificationPane
                    key={room.roomId}
                    roomId={room.roomId}
                    roomName={room.name}
                    userId={userId} />
            })}
        </Box>
    );
}
